/**
 * Created by Ning Jiang on 2021-05-04.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {TombstoneRipGameAssets} from "./TombstoneRipGameAssets";
import {TombstoneRipSound} from "./sound/TombstoneRipSound";
import {TombstoneRipBackground} from "./view/TombstoneRipBackground";
import {TombstoneRipWinPresentation} from "./gameflow/TombstoneRipWinPresentation";
import {TombstoneRipNormalBetPresentation} from "./gameflow/TombstoneRipNormalBetPresentation";
import {TombstoneRipNormalResultPresentation} from "./gameflow/TombstoneRipNormalResultPresentation";
import {TombstoneRipNormalIdlePresentation} from "./gameflow/TombstoneRipNormalIdlePresentation";
import {TombstoneRipModel} from "./server/TombstoneRipModel";
import {Layers, TombstoneRipLayers} from "./view/TombstoneRipLayers";
import {TombstoneRipReelController} from "./reels/TombstoneRipReelController";
import {TombstoneRipGameConfig} from "./TombstoneRipGameConfig";
import {ReelStopPresentationManager} from "./reelstoppresentation/ReelStopPresentationManager";
import {ReelStopSoundController} from "./reelstoppresentation/presentations/ReelStopSoundController";
import {WinPresentationManager} from "./winpresentation/WinPresentationManager";
import {WildLandingController} from "./reelstoppresentation/presentations/WildLandingController";
import {ScatterLandingController} from "./reelstoppresentation/presentations/ScatterLandingController";
import {Ways} from "./view/Ways";
import {Multiplier} from "./view/Multiplier";
import {TombstoneRipGameMode} from "./gameflow/TombstoneRipGameMode";
import {WildNudgeController} from "./winpresentation/presentations/WildNudgeController";
import {ReelSplitController} from "./winpresentation/presentations/ReelSplitController";
import {XSplitController} from "./winpresentation/presentations/XSplitController";
import {NoWinSymbolsController} from "./winpresentation/presentations/NoWinSymbolsController";
import {BetWaysInitialWinController} from "./winpresentation/presentations/initial/BetWaysInitialWinController";
import {InitialWinCountUp} from "./winpresentation/presentations/initial/InitialWinCountUp";
import {WaysWonCountUp} from "./winpresentation/presentations/initial/WaysWonCountUp";
import {XRipController} from "./winpresentation/presentations/XRipController";
import {BigWinController} from "./winpresentation/presentations/bigwin/BigWinController";
import {BigWinCountUp} from "./winpresentation/presentations/bigwin/BigWinCountUp";
import {IndividualWinController} from "./winpresentation/individual/IndividualWinController";
import {ReelWinHintController} from "./reelstoppresentation/presentations/ReelWinHintController";
import {DoubleScattersController} from "./winpresentation/presentations/DoubleScattersController";
import {FreespinIntro} from "./screen/FreespinIntro";
import {FreespinWinController} from "./winpresentation/presentations/FreespinWinController";
import {TombstoneRipFreespinIdlePresentation} from "./gameflow/TombstoneRipFreespinIdlePresentation";
import {FreespinOutro} from "./screen/FreespinOutro";
import {FreespinEndController} from "./winpresentation/presentations/FreespinEndController";
import {WinCapScreen} from "./screen/WinCapScreen";
import {BreakBankController} from "./winpresentation/presentations/BreakBankController";
import {SuperFsWinController} from "./winpresentation/presentations/SuperFsWinController";
import {TombstoneRipSuperFsResultPresentation} from "./gameflow/TombstoneRipSuperFsResultPresentation";
import {SuperFsMLandingController} from "./reelstoppresentation/presentations/SuperFsMLandingController";
import {SuperFsPop} from "./view/SuperFsPop";
import {UpgradeMController} from "./winpresentation/presentations/UpgradeMController";
import {FullScreenSmoke} from "./view/FullScreenSmoke";
import {Reel5Frame} from "./view/Reel5Frame";
import {XBetController} from "./view/XBetController";
import {ReelNearWinController} from "./reelstoppresentation/presentations/ReelNearWinController";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {IdleAnimationManager} from "./idle/IdleAnimationManager";
import {SymbolIdleController} from "./idle/animations/SymbolIdleController";
import {MainIdleDustController} from "./idle/animations/MainIdleDustController";
import {TumbleWeedController} from "./idle/animations/TumbleWeedController";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {Skinner} from "./Skinner";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {SkinLogo} from "./SkinLogo";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {AssetQualityLevel} from "@nolimitcity/slot-game/bin/asset/Asset";

export class TombstoneRip extends SlotGame {
    public static model:TombstoneRipModel;
    public static gameFlowController:GameFlowController;
    public static assetLoader:AssetLoader;
    public static reels:TombstoneRipReelController[];
    public static reelStopPresentations:ReelStopPresentationManager;
    public static winPresentations:WinPresentationManager;
    public static background:TombstoneRipBackground;
    public static ways:Ways;
    public static multiplier:Multiplier;
    public static initialCountUp:InitialWinCountUp;
    public static waysWon:WaysWonCountUp;
    public static bigWinCountUp:BigWinCountUp;
    public static individualWin:IndividualWinController;
    public static freespinIntro:FreespinIntro;
    public static freespinOutro:FreespinOutro;
    public static winCapScreen:WinCapScreen;
    public static superFsPop:SuperFsPop;
    public static reel5Frame:Reel5Frame;
    public static xBetController:XBetController;
    public static fullScreenSmoke:FullScreenSmoke;
    public static scatters:ScatterLandingController;
    public static idle:IdleAnimationManager;
    public static nearWin:ReelNearWinController;
    public static playFSWin:boolean = false;
    public static isActionSpinsActive:boolean = false;
    private skinner:Skinner;
    public static skinLogo:SkinLogo;

    constructor() {
        super();
        const validSkinIds:string[] = [
            "ug",
            "ozzo",
            "test",
            "sweep",
            "silvertech",
            "okgames",
            "us-nonfree"
        ]
        this.skinner = new Skinner(validSkinIds);
    }



    private handleSweepInit() {
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
            if (TombstoneRip.apiPlugin.gameClientConfiguration.replaceWordFree){
                this.skinner.skinId = "us-nonfree";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
                if (TombstoneRip.apiPlugin.gameClientConfiguration.replaceWordFree){
                    this.skinner.skinId = "us-nonfree";
                }
            })
        }
    }

    public async init():Promise<NolimitPlugin> {
        const value = await super.init();

        if(NolimitConfig.isDevMode) {
            // (<INolimitAudioPlayer>SlotGame.sound).showLogs(true);
        }

        TombstoneRipGameConfig.updateReelSets();
        TombstoneRip.model = new TombstoneRipModel(SlotGame.apiPlugin, true);
        TombstoneRip.gameFlowController = new GameFlowController(SlotGame.apiPlugin, TombstoneRip.model);
        TombstoneRip.gameFlowController.flowStateLogger.level = LogLevel.DEV;

        const normalIdle = new TombstoneRipNormalIdlePresentation();
        const normalBet = new TombstoneRipNormalBetPresentation();
        const normalResult = new TombstoneRipNormalResultPresentation();
        const winPres = new TombstoneRipWinPresentation();

        const freespinIdle = new TombstoneRipFreespinIdlePresentation();
        const superFsResult = new TombstoneRipSuperFsResultPresentation();

        TombstoneRip.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, normalIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        TombstoneRip.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));
        TombstoneRip.gameFlowController.addGameModeFlowStatePresentationMap(TombstoneRipGameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, normalBet],
            [FlowState.RESULT, superFsResult],
            [FlowState.WIN, winPres]
        ]));
        this.handleSweepInit();
        return value;
    }

    public async getReady():Promise<NolimitPlugin> {
        //Show intro and load game assets
        const value = await super.getReady();

        //Non views
        const sound = new TombstoneRipSound();
        const layers = new TombstoneRipLayers();

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(OpenSans.ITALIC_600);
        fontLoader.add(OpenSans.NORMAL_300);
        fontLoader.add(OpenSans.NORMAL_400);
        fontLoader.add(OpenSans.NORMAL_700);

        AssetsConfig.addToAssetsConfig(TombstoneRipGameAssets.RESOURCES_GROUPS);
        TombstoneRip.assetLoader = new AssetLoader(TombstoneRip.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("S1_overlay", "resources/images/S1_overlay.png");
        imgLoader.add("skinLogo", "resources/images/skinLogo.png");

        if(this.skinner.skinId!==undefined){
            TombstoneRipGameAssets.RESOURCES_GROUPS.main.forEach((ele)=>{
                if(ele.name==="main" || ele.name==="mainHigh"){
                    ele.autoLoad=[AssetQualityLevel.HIGH];
                }
            })
        }

        await Promise.all([fontLoader.load(), imgLoader.load(), TombstoneRip.assetLoader.load(ResourcesGroupName.MAIN)]);
        await this.handleSweepGetReady();
        await this.createViewsAndComponents();
        return value;
    }

    private handleSweepGetReady(): Promise<any> {
        if (this.skinner.skinId != undefined) {
            //Source folder for skin assets e.g "resources/images/skinName";
            const assetPath:string = "resources/images/";
            const replaceMap:Map<string, string> = new Map();

            if(this.skinner.skinId === "sweep"){
                replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
            } else if(this.skinner.skinId==="us-nonfree"){
                //Bonus
                replaceMap.set("fsintro/FREESPIN_INTRO", "FREESPIN_INTRO.png");
                replaceMap.set("fsintro/FREESPINS_INTRO", "FREESPINS_INTRO.png");
                replaceMap.set("fsintro/FREESPIN_SUPER_INTRO", "FREESPIN_SUPER_INTRO.png");
                replaceMap.set("fsintro/FREESPIN_SUPERS_INTRO", "FREESPIN_SUPERS_INTRO.png");
                replaceMap.set("FREESPIN", "FREESPIN.png");
                replaceMap.set("FREESPIN_SUPER", "FREESPIN_SUPER.png");

            }else{

                //Bonus
                replaceMap.set("FREESPIN", "FREESPIN.png");
                replaceMap.set("FREESPIN_SUPER", "FREESPIN_SUPER.png");

                replaceMap.set("S1_overlay", "S1_overlay.png");
                replaceMap.set("skinLogo", "skinLogo.png");

                //Intro
                replaceMap.set("entryBoard", "Entry_board.png");
                replaceMap.set("introDivUp", "Intro_Divider_up.png");
                replaceMap.set("feature1", "Intro_Feature_1.png");
                replaceMap.set("feature1NoBoosted", "Intro_Feature_1_NoBoosted.png");
                replaceMap.set("feature3", "Intro_Feature_3.png");

                //AS
                replaceMap.set("AS_GAME_LOGO", "AS_GAME_LOGO.png");
            }
            return  this.skinner.loadSkin(assetPath, replaceMap);
        }
        return Promise.resolve();
    }


    getPaytable():Promise<string> {
        const data = {
            imagePath:"screens/images/",
            sweepPath: "",
            usNonfreePath: "",
        };


        if (this.skinner.skinId != undefined) {
            if (this.skinner.skinId === "sweep") {
                data.sweepPath = `../resources/images/${this.skinner.skinId}/`;
            } else if(this.skinner.skinId === "us-nonfree"){
                data.usNonfreePath = `../resources/images/${this.skinner.skinId}/`;
            }else {
                data.imagePath = `../resources/images/${this.skinner.skinId}/`;
            }
        }
        return super.getPaytable().then((value: string) => {
            if (this.skinner.skinId === "sweep") {
                //don't have sweepPath in paytable
                value = value.replace(/{{imagePath}}{{sweepPath}}/g, data.sweepPath);
            }else if (this.skinner.skinId === "us-nonfree") {
                value = value.replace(/{{imagePath}}{{usNonfreePath}}/g, data.usNonfreePath);
            }
            const updatedValue = value.replace(/{{imagePath}}/g, data.imagePath);
            const flags = {
                showLowProbabilityGfx: TombstoneRip.apiPlugin.gameClientConfiguration.showLowProbabilityGfx,
                replaceWincapInfo: TombstoneRip.apiPlugin.gameClientConfiguration.replaceWincapInfo,
                showMultipliersInfo:TombstoneRip.apiPlugin.gameClientConfiguration.showMultipliersInfo,
                isUSPA: TombstoneRip.apiPlugin.gameClientConfiguration.jurisdictionName === "US-PA"
            }
            return TombstoneRip.apiPlugin.translations.render(updatedValue, flags);
        });
    }

    public async getReadyToStart():Promise<NolimitPlugin> {
        //Game assets loaded, showing intro, waiting for user to start game.
        TombstoneRipSound.switchMusic(
            {name : TombstoneRipSound.MAIN_GAME_MUSIC, volume : 0},
            {name : TombstoneRipSound.MAIN_GAME_MUSIC, from : 0, to : 1, duration : 1000}
        );

        return await super.getReadyToStart();
    }

    public async start():Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        const value = await super.start();

        this.restoreKeypadWin();
        TombstoneRip.gameFlowController.start();
        TombstoneRip.xBetController.start();
        // TombstoneRipSound.switchMusic({name : TombstoneRipSound.getMusicNameByMode(TombstoneRip.model.currentParsedData.mode)});

        return value;
    }

    private createViewsAndComponents() {
        //Views
        TombstoneRip.reels = [];
        for(let i:number = 0; i < TombstoneRipGameConfig.REELS_NUM; i++) {
            const reel = new TombstoneRipReelController(i);
            TombstoneRip.reels.push(reel);
        }
        TombstoneRip.background = new TombstoneRipBackground();
        TombstoneRip.xBetController = new XBetController();
        TombstoneRip.ways = new Ways();
        TombstoneRip.multiplier = new Multiplier();
        TombstoneRip.initialCountUp = new InitialWinCountUp();
        TombstoneRip.waysWon = new WaysWonCountUp();
        TombstoneRip.bigWinCountUp = new BigWinCountUp(TombstoneRipLayers.getLayer(Layers.BIG_WIN_COUNT_UP)!, 80);
        TombstoneRip.nearWin = new ReelNearWinController();
        TombstoneRip.reelStopPresentations = new ReelStopPresentationManager([
            TombstoneRip.nearWin,
            new ReelStopSoundController(),
            new WildLandingController(),
            new ScatterLandingController(),
            new ReelWinHintController(),
            new SuperFsMLandingController()
        ]);
        TombstoneRip.winPresentations = new WinPresentationManager([
            new UpgradeMController(), // S2 respin in main game.
            new WildNudgeController(),
            new DoubleScattersController(),
            new ReelSplitController(),
            new XSplitController(),
            new NoWinSymbolsController(),
            new XRipController(),
            new BetWaysInitialWinController(),
            new BigWinController(),
            new FreespinWinController(),
            new FreespinEndController(),
            new BreakBankController(),
            new SuperFsWinController()
        ]);
        TombstoneRip.individualWin = new IndividualWinController();
        TombstoneRip.freespinIntro = new FreespinIntro();
        TombstoneRip.freespinOutro = new FreespinOutro();
        TombstoneRip.winCapScreen = new WinCapScreen();
        TombstoneRip.reel5Frame = new Reel5Frame();
        TombstoneRip.superFsPop = new SuperFsPop();
        TombstoneRip.idle = new IdleAnimationManager([
            new SymbolIdleController(),
            new MainIdleDustController(),
            new TumbleWeedController()
        ]);

        TombstoneRip.skinLogo = new SkinLogo();

        // If restore, can be handled here directly or do in the constructor when it's created here.
    }

    private restoreKeypadWin():void {
        if(TombstoneRip.model.isRestore) {
            if(TombstoneRip.model.restoredFeatureBetName && TombstoneRip.model.restoredFeatureBetName.length > 0) {
                Logger.logDev(`#461----------TombstoneRip.createViewsAndComponents():restored feature bet name = ${TombstoneRip.model.restoredFeatureBetName}`);
                const activeBetFeature = SlotGame.apiPlugin.betFeatureController.getActiveBetFeature();
                if(!activeBetFeature) {
                    Logger.logDev(`#461----------TombstoneRip.createViewsAndComponents():api feature bet name not found, will set to ${TombstoneRip.model.restoredFeatureBetName}`);
                    SlotGame.apiPlugin.betFeatureController.setActiveBetFeature(TombstoneRip.model.restoredFeatureBetName);
                    const newActiveBetFeature = SlotGame.apiPlugin.betFeatureController.getActiveBetFeature();
                    if(newActiveBetFeature) {
                        Logger.logDev(`#461----------TombstoneRip.createViewsAndComponents():new set to api feature bet name = ${newActiveBetFeature.name}`);
                    }else {
                        Logger.logDev(`#461----------TombstoneRip.createViewsAndComponents():fail to set api feature bet name to = ${TombstoneRip.model.restoredFeatureBetName}`);
                    }
                } else {
                    Logger.logDev(`#461----------TombstoneRip.createViewsAndComponents():api feature bet name = ${activeBetFeature.name}`);
                }
            }
            if(TombstoneRip.model.parsedInitData.showTotalWin) {
                SlotGame.keypadPlugin.setWin(TombstoneRip.model.parsedInitData.totalWin, true, BelowStakeWinRestriction.isWinBelowStake());
            }
        }
    }

    getNoWinGameData():any {
        return {
            "reels" : [
                [
                    "L5",
                    "M3",
                    "L3",
                    "L1",
                    "L4"
                ],
                [
                    "M1",
                    "L3",
                    "L2",
                    "L5",
                    "L1"
                ],
                [
                    "M4",
                    "L4",
                    "L1",
                    "L2",
                    "L4"
                ],
                [
                    "M4",
                    "L3",
                    "M2",
                    "L4",
                    "L3"
                ],
                [
                    "M4",
                    "M3",
                    "M3",
                    "M4",
                    "M2"
                ]
            ],
            "evaluatedArea" : [
                [
                    "M3",
                    "L3",
                    "X"
                ],
                [
                    "L3",
                    "L2",
                    "L5"
                ],
                [
                    "L4",
                    "L1",
                    "L2"
                ],
                [
                    "L3",
                    "M2",
                    "L4"
                ],
                [
                    "M3",
                    "X",
                    "X"
                ]
            ],
            "betWayWins" : [],
            "totalSpinWinnings" : 0,
            "accumulatedRoundWin" : 0,
            "playedBetValue" : 1,
            "mode" : "NORMAL",
            "nextMode" : "NORMAL",
            "numberOfFreespinsPlayed" : 0,
            "freespinsLeft" : 0,
            "freespinTriggeredThisSpin" : false,
            "symbolSizes" : [
                [
                    1,
                    1,
                    0
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    1,
                    1,
                    1
                ],
                [
                    2,
                    0,
                    0
                ]
            ],
            "wasFeatureBuy" : false,
            "currentMultiplier" : 1,
            "brokeTheBank" : false,
            "xRip" : false,
            "xSplitPosition" : [
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ],
                [
                    false,
                    false,
                    false
                ]
            ],
            "wildMultipliersFS" : [
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ]
            ],
            "enhancedBet" : false
        };
    }
}